import React from 'react';

const LoadingSpinner = ({ size = 'medium', text = 'Loading...' }) => {
  const sizeClasses = {
    small: 'w-4 h-4',
    medium: 'w-8 h-8',
    large: 'w-12 h-12',
  };

  return (
    <div className="flex flex-col items-center justify-center p-8">
      <div className={`loading-spinner ${sizeClasses[size]} mb-4 border-emerald-500 border-t-transparent`}></div>
      <p className="text-gray-600 dark:text-gray-400 text-sm font-medium">{text}</p>
    </div>
  );
};

export default LoadingSpinner;
